import React from "react"
import * as Icon from "react-feather"
const navigationConfig = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/",
  },
  {
    id: "patient",
    title: "Patient",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/patient",

  },

  {
    id: "provider",
    title: "Provider",
    type: "item",
    icon: <Icon.Activity size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/provider",
  },
  {
    id: "insurance",
    title: "Insurance",
    type: "item",
    icon: <Icon.Thermometer size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/insurance",
  },
  {
    id: "specimen",
    title: "Specimen",
    type: "item",
    icon: <Icon.Underline size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/specimen",
  },
  {
    id: "results",
    title: "Results",
    type: "item",
    icon: <Icon.CheckCircle size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/results",
    children: [
      {
        id: "results",
        title: "Diagnosis",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/results"
      },
      {
        id: "fishscoring",
        title: "FISH Scoring",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/fishscoring"
      }
    ]
  },
  {
    id: "documents",
    title: "Documents",
    type: "item",
    icon: <Icon.Clipboard size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/documents",
  },
]

export default navigationConfig
